export const CREATE_ACH_REQUEST = "CREATE_ACH_REQUEST";
export const CREATE_ACH_SUCCESS = "CREATE_ACH_SUCCESS";
export const VIEW_ACH_REQUEST = "VIEW_ACH_REQUEST";
export const VIEW_ACH_SUCCESS = "VIEW_ACH_SUCCESS";
export const REMOVE_ACH_REQUEST = "REMOVE_ACH_REQUEST";
export const REMOVE_ACH_SUCCESS = "REMOVE_ACH_SUCCESS";
